import { IDataArray, User, Document } from "./../index";

export class Annotation implements IDataArray {
  public Id: number;
  public UserId: string;
  public DocumentId: number;
  public Submitted: Date;
  public Note: string;
  public IsPDF: boolean;

  public User: User = new User();
  public Document: Document = new Document();

  public GetById(): number {
    return this.Id;
  }
}
